import Vue from 'vue'
import VueUp from 'vueup'
import VueIntercom from 'vue-intercom'
import VueIntro from 'vue-introjs'
import Vuelidate from 'vuelidate'
import VueMoment from 'vue-moment'
import PortalVue from 'portal-vue'
import VTooltip from 'v-tooltip'
import FeatureFlags from '@/plugins/feature-flags'
import { i18n } from '@/plugins/i18n'

import {
  MdButton,
  MdContent,
  MdTabs,
  MdField,
  MdCheckbox,
  MdDatepicker,
  MdMenu,
  MdList,
  MdProgress,
  MdAutocomplete,
  MdTooltip,
  MdSwitch,
  MdRipple
} from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import 'flexboxgrid/dist/flexboxgrid.min.css'
import 'tether-drop/dist/css/drop-theme-arrows.css'
import 'intro.js/introjs.css'
import 'swiper/dist/css/swiper.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { polyfillLoader } from 'polyfill-io-feature-detection'
import rg4js from 'raygun4js'
import app from '@/app'
import router from '@/router'
import store from '@/store'
import '@/register-components'
import '@/register-directives'
import '@/highcharts-config'
import { Analytics } from '@/utils/analytics'
import { AppHolder } from '@/utils/app-holder'
import configFile from '@/../app-config.js'

export const bus = new Vue()

AppHolder.bus = bus

const bootstrapApp = () => {
  Vue.use(VueUp)
  Vue.use(VueIntro)
  Vue.use(Vuelidate)
  Vue.use(MdButton)
  Vue.use(MdContent)
  Vue.use(MdTabs)
  Vue.use(MdField)
  Vue.use(MdCheckbox)
  Vue.use(MdDatepicker)
  Vue.use(MdMenu)
  Vue.use(MdList)
  Vue.use(MdProgress)
  Vue.use(MdAutocomplete)
  Vue.use(MdTooltip)
  Vue.use(MdSwitch)
  Vue.use(MdRipple)
  Vue.use(VueMoment)
  Vue.use(PortalVue)
  Vue.use(VTooltip, {
    defaultPlacement: 'bottom',
    popover: {
      defaultPlacement: 'bottom'
    }
  })
  Vue.use(FeatureFlags, configFile[process.env.APP_ID].features)

  if (process.env.RAYGUN_ID) {
    rg4js('apiKey', process.env.RAYGUN_ID)
    rg4js('filterSensitiveData', ['password', 'credit_card'])
    Vue.config.errorHandler = function (err, vm, info) {
      rg4js('send', err)
    }
    rg4js('enableCrashReporting', true)
    rg4js('enablePulse', true)
    router.afterEach(to => {
      rg4js('trackEvent', {
        type: 'pageView',
        path: to.path
      })
    })
    store.watch(state => state.user.profile, value => {
      if (value && value.id) {
        const uuid = `user-${value.id}-${VERSION}`
        const isAdvisor = store.getters['auth/isAdvisor']

        const values = {
          identifier: value.id,
          isAnonymous: false,
          uuid
        }

        if (isAdvisor) {
          const { id } = store.state.auth.user
          values.uuid = `advisor-${id}-${uuid}`
          values.identifier = id
        }

        rg4js('setUser', values)
      }
    })
  }
  if (process.env.INTERCOM_ID) {
    Vue.use(VueIntercom, { appId: process.env.INTERCOM_ID })
  }
  if (Analytics.isAvailable()) {
    router.afterEach(to => {
      Analytics.page(to.name, to.path)
    })
    store.watch(state => state.user.profile, value => {
      if (value && value.email) {
        Analytics.identify(value.id, {
          name: (value.firstName && value.lastName) ? `${value.firstName} ${value.lastName}` : value.email,
          email: value.email
        })
      }
    })
  }

  Vue.config.productionTip = false

  // Remove old service workers
  if (navigator && navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => {
        for (let registration of registrations) {
          rg4js('send', new Error('Unregistered service worker'))
          registration.unregister()
        }
      })
  }

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    i18n,
    router,
    store,
    render: h => h(app)
  })
}

polyfillLoader({
  'features': 'Promise,String.prototype.includes,Array.prototype.find,Object.keys,Intl,Element.prototype.classList,Array.prototype.includes,Array.prototype.keys',
  'onCompleted': bootstrapApp
})
